"use client";
import {
  useSelectStore
} from "../__chunks/M6F5TFYH.js";
import {
  SelectContextProvider
} from "../__chunks/LM7KIZUU.js";
import "../__chunks/RUY5BUJG.js";
import "../__chunks/B7UTNDHN.js";
import "../__chunks/Y2U4BRIM.js";
import "../__chunks/T22PY7TE.js";
import "../__chunks/AMMIPFT4.js";
import "../__chunks/OLVWQA7U.js";
import "../__chunks/Y67KZUMI.js";
import "../__chunks/T2AZQXQU.js";
import "../__chunks/ABN76PSX.js";
import "../__chunks/APTFW6PT.js";
import "../__chunks/RTNCFSKZ.js";
import "../__chunks/5CPL3B7G.js";
import "../__chunks/VOQWLFSQ.js";
import "../__chunks/5GGHRIN3.js";
import "../__chunks/SK3NAZA3.js";
import "../__chunks/3YLGPPWQ.js";

// src/select/select-provider.tsx
import { jsx } from "react/jsx-runtime";
function SelectProvider(props = {}) {
  const store = useSelectStore(props);
  return /* @__PURE__ */ jsx(SelectContextProvider, { value: store, children: props.children });
}
export {
  SelectProvider
};
